import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Maps from '../../store/map';

function MyAccount(props) {
    const logout = () => {
        props.logoutUser();
        GoToPage('/');
    };

    const GoToPage = (path) => {
        props.history.push(path);
    };

    let { user } = props;

    return (
        <div className="main-container">
            <Row className="mx-auto p-3p bg-head-gray text-white">
                <Col xs="2" className="px-2 user-content">
                    <span className="fs-18 text-white">
                        <i className="icon-my-account"></i>
                    </span>
                    <span className="fs-13 d-block">{user.data.username}</span>
                </Col>
                <Col xs="9" className="pr-0 fs-18 py-2">
                    {parseFloat(user.data.balance).toFixed(2)} EUR
                </Col>
            </Row>
            <Row className="mx-auto icon-gray py-3 fs-18">
                <Col xs="2" className="pl-2 pr-1 text-center ">
                    <i className="icon-transaction"></i>
                </Col>
                <Col xs="10" md="10" className="pl-0 text-left">
                    Transaction
                </Col>
            </Row>
            <div className="my-account-divider"></div>
            <Row className="mx-auto icon-gray py-3 fs-18">
                <Col xs="2" className="pl-2 pr-1 text-center ">
                    <i className="icon-password"></i>
                </Col>
                <Col xs="10" md="10" className="pl-0 text-left">
                    Change password
                </Col>
            </Row>
            <div className="my-account-divider"></div>
            <Row className="mx-auto icon-gray py-3 fs-18">
                <Col xs="2" className="pl-2 pr-1 text-center ">
                    <i className="icon-logout"></i>
                </Col>
                <Col xs="10" className="pl-0 text-left" onClick={logout}>
                    Logout
                </Col>
            </Row>
            <div className="my-account-divider"></div>
        </div>
    );
}

export default connect(Maps.mapUserStateToProps, Maps.mapUserDispatchToProps)(MyAccount);
